import Vue from 'vue';
import ElementUI from 'element-ui';
import components from '@/components/index.js';
import App from './App.vue';
import router from './router/index.js';
import store from './store/index.js';
import api from './http/api.js';
import filters from './filter/index.js';
import directives from './directives/index.js';
import utils from './utils/utils.js';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/common.scss';
import './assets/css/custom.scss';
import './assets/css/reset.scss';
import './assets/css/iconfont.css';
import './assets/css/scanMent.scss';

require('@/assets/download.jpg');

const bus = new Vue();
Vue.prototype.$bus = bus;
Vue.prototype.$api = api;
Vue.prototype.$util = utils;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(components);
Vue.use(filters);
Vue.use(directives);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
